/*
* This is shared interface so you do not have to import 3rd parties frontend dependent libraries
* */
export interface MutationResult<T>{
  data?: T | null | undefined;
  extensions?: unknown;
  context?: unknown;
  loading: boolean;
}
